// テナント外見情報
// 製品名はビルド時に注入される REACT_APP_PRODUCT_NAME を唯一の情報源とする。
// （env/.env.<tenant> で定義 → index.html の <title> と本マップで共用）
const productName = process.env.REACT_APP_PRODUCT_NAME ?? 'Contacts'

export type TenantBrand = {
  productName: string // 画面表示用の製品名
  logoAlt: string // ロゴ画像の alt テキスト
}

export const getTenantBrand = (): TenantBrand => ({
  productName,
  logoAlt: `${productName}ロゴ画像`,
})
